module.exports = __webpack_public_path__ + "img/thumb_17.6ed30a97.jpg";